export const themes = {
  light: {
    bg: '#ffffff',
    bgSecondary: '#f8f8fc',
    bgCard: '#ffffff',
    nav: '#12121a',
    navText: '#ffffff',
    text: '#1a1a2e',
    textMuted: '#6b6b8a',
    border: '#e2e2f0',
    input: '#f5f5f5',
    inputBorder: '#e2e2f0',
    inputText: '#1a1a2e',
    primary: '#7c6af7',
    danger: '#f76a8a',
    success: '#6af7c2',
    warning: '#f7a06a',
    cardBg: '#ffffff',
    cardBorder: '#e2e2f0',
  },
  dark: {
    bg: '#0a0a0f',
    bgSecondary: '#12121a',
    bgCard: '#16161f',
    nav: '#080810',
    navText: '#ffffff',
    text: '#e2e2f0',
    textMuted: '#6b6b8a',
    border: '#1e1e2e',
    input: 'rgba(255,255,255,0.06)',
    inputBorder: 'rgba(255,255,255,0.1)',
    inputText: '#ffffff',
    primary: '#7c6af7',
    danger: '#f76a8a',
    success: '#6af7c2',
    warning: '#f7a06a',
    cardBg: '#12121a',
    cardBorder: '#1e1e2e',
  }
}
